export interface NewsItem {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  image: string;
  tag: string;
  content: {
    intro: string;
    sections: { heading: string; body: string; image?: string }[];
    closing: string;
  };
}

export const newsItems: NewsItem[] = [
  {
    id: 1,
    category: "新品到貨",
    title: "春夏新品正式上架｜都會輕薄系列登場",
    excerpt: "精選台灣設計師品牌春夏經典款，薄透雪紡、涼感針織、輕盈洋裝，讓您在炎熱天氣中依然優雅有型。",
    date: "2024-04-08",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20women%20fashion%20spring%20summer%20new%20collection%20light%20chiffon%20dress%20warm%20cream%20beige%20boutique%20display%20designer%20brand%20quality%20wide%20shot&width=1200&height=640&seq=news001&orientation=landscape",
    tag: "新品",
    content: {
      intro: "期待已久的春夏新品系列正式上架！本季我們精選了台灣設計師品牌最受歡迎的春夏經典款，以更親切的 Outlet 價格讓每一位愛好質感穿著的女性都能輕鬆入手。",
      sections: [
        {
          heading: "本季主打：輕盈雪紡系列",
          body: "以進口雪紡面料打造的春夏系列，是本季最受矚目的新品。垂墜感十足的雪紡面料，在輕風中飄逸優雅，非常適合春夏的各種戶外場合。本系列包含雪紡寬管長褲、雪紡連身裙及雪紡上衣，可單搭也可組合成整套穿著。",
          image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20women%20spring%20chiffon%20dress%20new%20arrival%20boutique%20display%20warm%20cream%20beige%20background%20designer%20quality%20light%20fabric%20fashion&width=800&height=500&seq=news001a&orientation=landscape"
        },
        {
          heading: "涼感針織：舒適與優雅兼顧",
          body: "針對夏季辦公室冷氣環境，本季特別引進多款涼感針織系列。材質輕薄透氣，同時具備足夠的覆蓋性，穿著時不會感到悶熱，是夏日職場穿搭的最佳選擇。",
        },
        {
          heading: "新品上架特惠",
          body: "即日起至本月底，所有春夏新品享有 9 折優惠。加入 LINE 官方帳號的會員，更可享有額外 5% 折扣。歡迎親自到台中門市試穿，感受面料的質感與版型的修飾效果。",
        }
      ],
      closing: "新品數量有限，建議早日前往台中門市試穿或加入 LINE 詢問庫存，以免向隅。期待在門市與您相遇！"
    }
  },
  {
    id: 2,
    category: "門市活動",
    title: "四月門市特別活動｜親子試穿日限定優惠",
    excerpt: "本月每週六上午特別舉辦造型諮詢活動，由專業造型顧問提供一對一搭配建議，歡迎攜伴同來體驗。",
    date: "2024-04-05",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20boutique%20styling%20consultation%20event%20warm%20cream%20interior%20professional%20stylist%20taiwanese%20designer%20brand%20quality%20atmosphere%20wide%20shot&width=1200&height=640&seq=news002&orientation=landscape",
    tag: "活動",
    content: {
      intro: "為了讓更多顧客能親身體驗我們的造型服務，本月每週六上午特別規劃「造型諮詢日」活動，由資深造型顧問一對一為您提供穿搭建議！",
      sections: [
        {
          heading: "活動內容",
          body: "每週六上午 10:00–12:00，門市提供免預約的一對一造型諮詢服務。造型顧問將根據您的身材特徵、日常場合需求和個人風格偏好，為您推薦最適合的款式與搭配方式。",
          image: "https://readdy.ai/api/search-image?query=professional%20fashion%20stylist%20consultation%20one%20on%20one%20boutique%20elegant%20mature%20taiwanese%20woman%20warm%20interior%20cream%20background%20quality%20service%20fashion&width=800&height=500&seq=news002a&orientation=landscape"
        },
        {
          heading: "限定優惠",
          body: "參與造型諮詢日的顧客，當日購買任一商品即享 85 折優惠，並贈送精美品牌提袋一個。活動限量 20 位名額，建議提前加入 LINE 登記，確保您的諮詢時段。",
        },
        {
          heading: "如何參加",
          body: "無需預約，直接於活動時間到達台中門市即可參加。若希望保留指定時段，可加入 LINE 官方帳號登記，我們會在前一天發送提醒通知。",
        }
      ],
      closing: "期待在活動中與您相見，讓我們的造型顧問幫您找到最適合的質感穿搭！"
    }
  },
  {
    id: 3,
    category: "換季特賣",
    title: "秋冬換季出清｜指定款式限時優惠",
    excerpt: "精選秋冬外套、厚針織系列限時特惠，以 Outlet 超值價格入手經典設計師品牌，數量有限，售完為止。",
    date: "2024-03-28",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20autumn%20winter%20clearance%20sale%20boutique%20warm%20beige%20tones%20taiwanese%20designer%20outlet%20jacket%20coat%20collection%20quality%20wide%20shot&width=1200&height=640&seq=news003&orientation=landscape",
    tag: "特賣",
    content: {
      intro: "季節交替之際，是入手質感設計師品牌服飾的最佳時機。本次換季出清精選多款秋冬外套與厚針織系列，以超值的 Outlet 價格呈現，讓您以更親切的價格擁有經典品牌質感。",
      sections: [
        {
          heading: "特賣商品一覽",
          body: "本次特賣涵蓋長版羊毛外套、格紋西裝外套、厚針織毛衣、修身長褲等多款秋冬經典款式。每件商品均為台灣設計師品牌正品，部分款式甚至是多年前的熱銷經典，在二手市場依然炙手可熱。",
          image: "https://readdy.ai/api/search-image?query=autumn%20winter%20clothing%20sale%20display%20rack%20elegant%20boutique%20warm%20beige%20interior%20taiwanese%20designer%20brand%20quality%20coat%20jacket%20wool%20collection&width=800&height=500&seq=news003a&orientation=landscape"
        },
        {
          heading: "特賣價格",
          body: "所有特賣商品均享有 5–7 折優惠，部分庫存僅剩少量尺寸，以「先到先得」原則販售。建議有興趣的顧客盡早前往試穿，或加入 LINE 詢問指定款式的庫存狀況。",
        },
        {
          heading: "特賣期間",
          body: "本次換季特賣即日起至本月底，或售完為止。部分熱門款式可能提早售罄，建議把握機會及早前往選購。",
        }
      ],
      closing: "Outlet 不等於廉價，每一件特賣商品都代表著設計師品牌的工藝與品質。把握換季特賣，讓您的衣橱加入一件真正值得珍藏的經典。"
    }
  },
  {
    id: 4,
    category: "節日優惠",
    title: "母親節特輯｜送給最愛的她最貼心的禮物",
    excerpt: "母親節即將到來，精選適合媽媽、婆婆與長輩的優雅服飾，每一件都是表達心意最好的方式。",
    date: "2024-03-20",
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20mother%20wearing%20designer%20outfit%20graceful%20warm%20rose%20beige%20background%20mothers%20day%20gift%20quality%20fashion%20wide%20shot&width=1200&height=640&seq=news004&orientation=landscape",
    tag: "節日",
    content: {
      intro: "母親節即將到來，今年不如送給媽媽一份真正用得上、穿得出去的禮物——一件她一直想要卻捨不得買的質感設計師品牌服飾。",
      sections: [
        {
          heading: "為什麼服飾是最好的禮物",
          body: "媽媽們往往習慣把最好的留給家人，而將自己的需求放在最後。一件精心挑選、符合她風格的優雅服飾，不只是物質上的禮物，更是告訴她「你值得擁有最好的」這句話最有力的表達。",
          image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20happy%20receiving%20gift%20fashion%20boutique%20warm%20interior%20rose%20beige%20quality%20designer%20brand%20mother%20daughter%20graceful&width=800&height=500&seq=news004a&orientation=landscape"
        },
        {
          heading: "母親節推薦款式",
          body: "針對母親節，我們特別整理了幾款最受熟齡女性喜愛的商品推薦：修身洋裝（適合聚餐與出遊）、優雅套裝組（適合正式場合）、質感針織上衣（日常百搭）與氣質長版外套（早晚溫差適用）。",
        },
        {
          heading: "母親節禮物包裝服務",
          body: "即日起至母親節前，凡購買指定禮物商品，均提供免費精美禮盒包裝服務。歡迎加入 LINE 諮詢或直接到台中門市挑選，我們的造型顧問很樂意為您提供選購建議。",
        }
      ],
      closing: "感謝媽媽多年來的付出，讓她也能穿上最美的自己。祝天下所有的媽媽母親節快樂！"
    }
  },
  {
    id: 5,
    category: "限量到貨",
    title: "限量聯名款到貨｜經典格紋系列僅此一批",
    excerpt: "與設計師聯名推出的限量格紋系列正式到貨，優雅復古的格紋版型搭配現代剪裁，數量極為有限。",
    date: "2024-03-15",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20limited%20edition%20plaid%20designer%20collection%20taiwan%20fashion%20boutique%20warm%20cream%20background%20quality%20fabric%20sophisticated%20mature%20style%20wide%20shot&width=1200&height=640&seq=news005&orientation=landscape",
    tag: "限量",
    content: {
      intro: "這是我們與品牌設計師特別合作的限量聯名款系列，只此一批，無法補貨。如果您一直在等待一件真正獨特的設計師單品，這就是您的機會！",
      sections: [
        {
          heading: "聯名系列設計理念",
          body: "本次聯名系列以「都會復古優雅」為主題，將品牌 30 年經典的格紋元素，以現代剪裁重新詮釋。每一件都保留了設計師品牌一貫的精工細節，同時融入了更符合當代熟齡女性審美的版型設計。",
          image: "https://readdy.ai/api/search-image?query=elegant%20limited%20edition%20plaid%20fashion%20collection%20display%20boutique%20mature%20taiwanese%20woman%20designer%20brand%20quality%20fabric%20sophisticated%20vintage%20modern%20warm%20cream&width=800&height=500&seq=news005a&orientation=landscape"
        },
        {
          heading: "限量款式介紹",
          body: "本次系列共包含三款：格紋長版外套（限量 15 件）、格紋修身洋裝（限量 20 件）、格紋寬管長褲（限量 18 件）。每款均有多色可選，但每色每尺寸數量極為稀少。",
        },
        {
          heading: "如何購入",
          body: "限量款目前只在台中門市展示銷售，不接受網路訂購。建議盡快到店試穿，或加入 LINE 詢問目前剩餘庫存，由造型顧問為您保留心儀款式。",
        }
      ],
      closing: "限量款售完即止，不接受補單。如有興趣，請盡快加入 LINE 或前往台中門市，把握這次唯一的機會！"
    }
  },
  {
    id: 6,
    category: "穿搭活動",
    title: "IG 穿搭挑戰活動｜分享你的質感日常",
    excerpt: "即日起至月底，分享你在本店購買服飾的穿搭照片至 IG，標記我們即有機會獲得精美禮品卡。",
    date: "2024-03-10",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20woman%20outfit%20sharing%20social%20media%20graceful%20urban%20style%20warm%20cream%20background%20designer%20fashion%20brand%20quality%20photography%20wide%20shot&width=1200&height=640&seq=news006&orientation=landscape",
    tag: "活動",
    content: {
      intro: "我們相信每一位顧客都是最好的品牌代言人！即日起舉辦 IG 穿搭挑戰活動，邀請您分享穿著本店服飾的日常穿搭，讓更多人看見屬於成熟女性的優雅質感。",
      sections: [
        {
          heading: "活動辦法",
          body: "購買本店任一服飾後，將穿搭照片上傳至 Instagram，並標記本店帳號與 #質感Outlet穿搭 標籤。每位參與者都有機會獲得品牌禮品卡，活動期間分享越多，中獎機率越高！",
          image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20fashion%20photography%20outfit%20instagram%20lifestyle%20graceful%20warm%20light%20quality%20clothing%20styled%20photo%20day&width=800&height=500&seq=news006a&orientation=landscape"
        },
        {
          heading: "獎品介紹",
          body: "本次活動設有三等獎項：頭獎為 NT$5,000 購物禮品卡（共 1 名），二獎為 NT$2,000 購物禮品卡（共 3 名），三獎為 NT$1,000 購物禮品卡（共 5 名）。另外，每週精選最具質感的穿搭照，給予 NT$500 限時優惠碼。",
        },
        {
          heading: "活動期間與結果公告",
          body: "活動即日起至本月最後一天截止。得獎名單將於次月初在 Instagram 公告，並私訊通知得獎者。如有任何問題，歡迎加入 LINE 官方帳號詢問。",
        }
      ],
      closing: "分享你的質感穿搭，讓你的美麗被更多人看見！我們期待看到每一位顧客獨特的風格表達。"
    }
  },
  {
    id: 7,
    category: "新品到貨",
    title: "夏日渡假風新品到貨｜輕盈印花洋裝系列",
    excerpt: "來自台灣設計師品牌的夏日渡假系列正式上架，清新印花搭配寬鬆剪裁，是夏季外出旅遊的最佳選擇。",
    date: "2024-03-05",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20women%20summer%20resort%20dress%20floral%20print%20new%20arrival%20boutique%20display%20warm%20sandy%20beige%20background%20designer%20quality%20breezy%20wide%20shot&width=1200&height=640&seq=news007&orientation=landscape",
    tag: "新品",
    content: {
      intro: "夏日旅遊季即將到來，本次新品系列特別以「渡假輕盈」為主題，為熟齡女性打造既優雅又舒適的夏日穿搭選擇。",
      sections: [
        {
          heading: "印花洋裝系列",
          body: "本次新品主打清新印花設計，花卉與幾何圖案並陳，色調以米白、淡粉、海水藍為主，適合各種夏日場合——無論是海邊渡假、城市漫步還是午後聚會，都能穿出恰到好處的優雅感。",
          image: "https://readdy.ai/api/search-image?query=summer%20floral%20dress%20display%20elegant%20boutique%20warm%20sandy%20background%20designer%20quality%20taiwanese%20fashion%20resort%20collection%20wide%20shot&width=800&height=500&seq=news007a&orientation=landscape"
        },
        {
          heading: "寬鬆版型的舒適哲學",
          body: "本系列特別採用寬鬆版型設計，兼顧舒適度與視覺修飾效果。面料選用吸濕排汗的天絲棉混紡，在炎熱的夏日依然保持清爽，長時間穿著也不覺悶熱。",
        },
        {
          heading: "搭配建議",
          body: "渡假洋裝搭配草編帽與平底涼鞋，是最經典的夏日造型；若用於城市穿搭，換上低跟穆勒鞋並加上輕薄外搭，即刻提升整體質感。我們的造型顧問可為您提供個人化搭配建議。",
        }
      ],
      closing: "夏日新品數量有限，歡迎前往台中門市試穿，感受夏日渡假的輕盈氛圍！"
    }
  },
  {
    id: 8,
    category: "門市活動",
    title: "五月週年慶特別活動｜滿額贈限量提袋",
    excerpt: "門市迎來週年慶！整個五月購物滿 NT$3,000 即贈限量品牌帆布提袋，另有多項週年獨家優惠。",
    date: "2024-02-28",
    image: "https://readdy.ai/api/search-image?query=boutique%20anniversary%20celebration%20elegant%20fashion%20store%20warm%20cream%20interior%20display%20designer%20brand%20gift%20bag%20promotional%20event%20taiwan%20mature%20woman%20quality&width=1200&height=640&seq=news008&orientation=landscape",
    tag: "活動",
    content: {
      intro: "感謝各位顧客長期以來的支持與愛護，我們迎來了門市週年紀念！整個五月份將舉辦一系列週年慶活動，以回饋對品質穿搭有所堅持的您。",
      sections: [
        {
          heading: "週年慶活動辦法",
          body: "整個五月份，單筆購物滿 NT$3,000 即贈限量品牌帆布提袋一個（共 100 個，送完為止）；滿 NT$5,000 加贈精裝品牌手冊與香氛小禮。所有週年慶商品同步享有 9 折優惠。",
          image: "https://readdy.ai/api/search-image?query=anniversary%20gift%20bag%20canvas%20tote%20elegant%20brand%20quality%20boutique%20warm%20cream%20interior%20celebration%20fashion%20taiwan%20designer%20special%20edition&width=800&height=500&seq=news008a&orientation=landscape"
        },
        {
          heading: "限量款式首發",
          body: "週年慶期間還將首發三款限量設計師聯名款式，為本季壓軸之作。這些款式僅於週年慶期間供應，且數量極為稀少，建議有意入手的顧客提早加入 LINE 詢問預留。",
        },
        {
          heading: "老顧客專屬優惠",
          body: "曾在本店消費過的老顧客，憑過去的購買記錄或 LINE 官方帳號綁定身份，可額外享有 5% 的週年慶老顧客回饋折扣，可與其他優惠疊加使用。",
        }
      ],
      closing: "週年慶是我們回饋支持的方式，感謝每一位走進門市、信任我們品味的顧客。五月見！"
    }
  },
  {
    id: 9,
    category: "換季特賣",
    title: "春季尾聲出清特賣｜精選設計師款 6 折起",
    excerpt: "春季尾聲，多款台灣設計師品牌精選款式限時出清，最低 6 折，讓您以超值價格入手心儀的質感服飾。",
    date: "2024-02-20",
    image: "https://readdy.ai/api/search-image?query=elegant%20spring%20clearance%20sale%20boutique%20designer%20taiwanese%20fashion%20warm%20peach%20beige%20interior%20rack%20display%20quality%20brand%20discounted%20price%20clothing%20collection%20wide&width=1200&height=640&seq=news009&orientation=landscape",
    tag: "特賣",
    content: {
      intro: "春天即將進入尾聲，是時候為您的衣橱做最後一次春季補充了！本次出清特賣精選多款春季設計師品牌服飾，以 6 至 8 折的超值價格，讓您以更輕鬆的預算擁有高品質的質感穿搭。",
      sections: [
        {
          heading: "特賣款式精選",
          body: "本次特賣商品包含：輕薄雪紡外套（原價 NT$5,800，特賣 NT$3,480）、春日碎花洋裝（原價 NT$4,200，特賣 NT$2,520）、修身棉麻長褲（原價 NT$3,600，特賣 NT$2,160）等多款春季主力款式。",
          image: "https://readdy.ai/api/search-image?query=spring%20fashion%20sale%20rack%20elegant%20boutique%20warm%20peach%20interior%20designer%20brand%20quality%20discounted%20clothing%20display%20taiwan%20mature%20woman%20fashion&width=800&height=500&seq=news009a&orientation=landscape"
        },
        {
          heading: "特賣注意事項",
          body: "特賣商品均為現貨庫存，售完不補貨。部分款式尺寸可能不齊，建議提早前往選購。本次特賣不接受網路訂購，需親至台中門市挑選，現場結帳享有特賣價格。",
        },
        {
          heading: "造型師搭配建議",
          body: "雖是特賣品，每件服飾的品質依然保有原廠水準。我們的造型顧問會在特賣期間常駐門市，協助您挑選最適合的款式並提供搭配建議，確保每一件入手的服飾都能真正融入您的日常穿搭。",
        }
      ],
      closing: "春季特賣是每年最受顧客期待的活動之一，歡迎廣邀好友一同前來選購！"
    }
  },
  {
    id: 10,
    category: "新品到貨",
    title: "秋冬預購開始｜早鳥優惠限時開放",
    excerpt: "下一季秋冬系列現已開放早鳥預購，精選羊毛大衣、厚針織與修身西裝套裝，預購享 9 折早鳥優惠。",
    date: "2024-02-15",
    image: "https://readdy.ai/api/search-image?query=elegant%20autumn%20winter%20preorder%20new%20collection%20boutique%20taiwanese%20designer%20brand%20warm%20terracotta%20brown%20beige%20background%20quality%20wool%20coat%20preview%20fashion%20wide%20shot&width=1200&height=640&seq=news010&orientation=landscape",
    tag: "新品",
    content: {
      intro: "跟上時尚節奏的您，現在就可以搶先預訂下一季的秋冬新品！本次早鳥預購開放多款設計師品牌秋冬主力款，讓您在新品正式上架前確保入手心儀款式。",
      sections: [
        {
          heading: "本季秋冬主打款",
          body: "下一季秋冬系列以「都會暖意」為主題，主打色系為焦糖棕、杏仁白與深酒紅。重點款式包括：喀什米爾混紡長版大衣、義式格紋西裝套裝、羊駝毛寬版厚針織上衣，以及修身直筒羊毛長褲。",
          image: "https://readdy.ai/api/search-image?query=autumn%20winter%20collection%20preview%20elegant%20boutique%20warm%20brown%20terracotta%20interior%20coat%20wool%20knitwear%20display%20taiwanese%20designer%20quality%20fashion%20preorder&width=800&height=500&seq=news010a&orientation=landscape"
        },
        {
          heading: "早鳥預購優惠",
          body: "即日起至本月底完成預購者，享有 9 折早鳥優惠，並優先於其他顧客取得商品。預購需支付 30% 訂金，餘款於商品到貨通知後 7 日內付清，到貨後可選擇門市自取或付費宅配。",
        },
        {
          heading: "如何預購",
          body: "加入 LINE 官方帳號後，向我們的顧問說明您有興趣的款式、顏色與尺寸，顧問將為您確認庫存並協助完成預購流程。或直接前往台中門市，現場查看樣品並完成預購。",
        }
      ],
      closing: "錯過早鳥優惠就要等到新品正式上架才能購買，而那時熱門尺寸可能已經所剩無幾。把握預購機會，讓今年秋冬的衣橱從現在就開始精心規劃！"
    }
  },
];

export const newsCategories = ["全部","新品到貨","門市活動","換季特賣","節日優惠","限量到貨","穿搭活動"];

export const tagColors: Record<string, string> = {
  新品: "bg-[#8B5E52] text-white",
  活動: "bg-[#3d2b1f] text-[#f5e8d8]",
  特賣: "bg-[#c9a98a] text-[#3d2b1f]",
  節日: "bg-[#b8957a] text-white",
  限量: "bg-[#7a5a4a] text-white",
};
